import { render, staticRenderFns } from "./LegalPay.vue?vue&type=template&id=9300797c&"
import script from "./LegalPay.vue?vue&type=script&lang=js&"
export * from "./LegalPay.vue?vue&type=script&lang=js&"
import style0 from "./LegalPay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports